import { render } from "./ProjectCredits.vue?vue&type=template&id=768a2f73"
import script from "./ProjectCredits.vue?vue&type=script&lang=js"
export * from "./ProjectCredits.vue?vue&type=script&lang=js"

import "./ProjectCredits.vue?vue&type=style&index=0&id=768a2f73&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__